import React from 'react'
import moment from 'moment'
import { Button, CircularProgress } from '@mui/material'
import { useSnackbar } from 'notistack'
import DownloadIcon from '@mui/icons-material/Download'

const ExportButton = ({ exportApi, fileLabel }) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleExport = async () => {
    try {
      // Get file
      const res = await exportApi.mutateAsync()

      // Get timestamp
      const timestamp = moment().format('YYYYMMDDHHmmss')
      const url = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileLabel}_${timestamp}.xlsx`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to export data', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <Button
      startIcon={exportApi.isLoading ? <CircularProgress size='1.5rem' /> : <DownloadIcon />}
      onClick={handleExport}
      disabled={exportApi.isLoading}
    >
      Export Data
    </Button>
  )
}

export default ExportButton
